module.exports = __webpack_public_path__ + "static/media/logo.801b3522.png";